exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StaggeredFade > * {\n  transition: all 0.3s ease-in-out;\n}\n", ""]);

// exports
